<template>
  <subject-info-form
    v-if="childComponentLoader"
    :formEdit="formEdit"
    :isEditPage="true"
    :serverValidations="serverValidations"
    @on-submit="editSubject"
  >
    <template v-slot:table>
      <div>
        <p class="ml-4 mt-5 list-classes">
          {{ $t("subject.list_graduation") }} {{ formEdit.name }} ({{
            formEdit.graduation_category.length
          }})
        </p>
        <ol
          class="ml-4 mt-2"
          v-for="(item, index) in formEdit.graduation_category"
          :key="index"
        >
          <li>{{ index + 1 }}. {{ item.name }}</li>
        </ol>
      </div>
      <p class="ml-4 mt-5 list-classes">
        {{ $t("subject.list_of_class") }}
      </p>
      <div class="form-table">
        <yv-index
          :path="path"
          :columns="columns"
          :tableActionsComponent="TableActions"
          :disabledHeaderActions="true"
          :sortable="sortable"
          :sort-data="sortData"
          :formatTableData="formatTableData"
        >
        </yv-index>
      </div>
    </template>
  </subject-info-form>
</template>

<script>
import SubjectInfoForm from "./SubjectInfoform.vue";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { genErrMsgOj } from "@/helpers/utils";
import { subject_router_names } from "@/routes/routes";
import YvIndex from "@/components/Base/YvIndex.vue";
import TableActions from "./TableActions";
export default {
  components: { SubjectInfoForm, YvIndex },
  data() {
    return {
      TableActions,
      formEdit: {},
      childComponentLoader: false,
      serverValidations: {},
      path: `${service_paths.classes}/?subject_id=${this.$route.params.id}`,
      sortable: ["name", "status", "terms"],
      columns: {
        name: "class.col_class_name",
        term: "class.col_term",
        status: "class.col_status",
        graduation_category: "subject.graduation_category"
      },
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      }
    };
  },
  created() {
    this.fetchSubject();
  },
  methods: {
    formatTableData(table) {
      if (!table) {
        return table;
      }
      return table.map(item => {
        item.term = item.terms.name;
        return item;
      });
    },
    fetchSubject() {
      const subject_id = this.$route.params.id;
      this.$axios
        .get(`${service_paths.subjects}/${subject_id}`)
        .then(response => {
          this.formEdit = response.data;
          this.childComponentLoader = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    editSubject(formData) {
      console.log(formData);
      if (formData.credit === "") {
        formData.credit = null;
      }
      const subject_id = this.$route.params.id;
      this.$axios
        .put(`${service_paths.subjects}/${subject_id}`, formData)
        .then(() => {
          Message.success(this.$t("common.successfully"));
          this.$router.push({ name: subject_router_names.listPage });
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
            console.log("this.serverValidations: ", this.serverValidations);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.list-classes {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
</style>
